import qs from './qs';

let langs;

if (navigator.languages) {
  langs = navigator.languages.slice();
} else {
  langs = [navigator.language || navigator.userLanguage];
}

if (qs('lang')) {
  langs.unshift(qs('lang'));
}

/* eslint-disable global-require */

const langFiles = {
  'en-GB': require('../i18n/en-GB.json'),
  'ar-SA': require('../i18n/ar-SA.json'),
  'zh-CN': require('../i18n/zh-CN.json'),
  'zh-HK': require('../i18n/zh-HK.json'),
};

/* eslint-enable global-require */

const langFile = langs
  .map((lang) => langFiles[lang])
  .filter((file) => file)[0];

const i18n = langFile || langFiles['en-GB'];
export default i18n;

// Inject translations into page
[].slice.call(document.querySelectorAll('[data-i18n]')).forEach((el) => {
  el.textContent = i18n[el.dataset.i18n];
});



// WEBPACK FOOTER //
// ./src/js/lib/i18n.js